import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'duration',
  standalone: true
})
export class DurationPipe implements PipeTransform {
  transform(amount: number, unit: string = 'months'): string {
    let returnString: string = amount + ' ';
    switch (unit) {
      case 'days':
        returnString += amount === 1 ? 'dag' : 'dagen';
        break;
      case 'weeks':
        returnString += amount === 1 ? 'week' : 'weken';
        break;
      case 'months':
        returnString += amount === 1 ? 'maand' : 'maanden';
        break;
      case 'years':
        returnString += 'jaar';
        break;
    }

    return returnString;
  }
}
